import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { maskPhone } from "../../../utils/masks";
import { useConcessionariaBusca } from "../../../hooks/queries/cliente/useConcessionariaBusca/useConcessionariaBusca";
import { Tracking } from "../../../services/Tracking";
import { IAtendimentoConcessionariaForm } from "../../../types/agendamento";
import { ISelectOptions } from "../../../types/inputs";

export type IFormDeliveryConcessionaireV2Values = IAtendimentoConcessionariaForm;

const schema = z.object({
  nome: z.string().min(1, "Campo obrigatorio"),
  telefone: z.string().min(9, "Campo obrigatorio"),
  uuidConcessionaria: z.string().min(1, "Você precisa selecionar uma concessionária"),
});

export const useFormDeliveryConcessionaireV2 = () => {
  const {
    control,
    handleSubmit,
    setValue,
    watch,
    register,
    formState: { errors },
  } = useForm<IFormDeliveryConcessionaireV2Values>({
    defaultValues: {
      nome: "",
      telefone: "",
      uuidConcessionaria: "",
    },
    resolver: zodResolver(schema),
    mode: "all",
  });

  const telefoneDigitado = watch("telefone");

  const { buscarConcessionarias } = useConcessionariaBusca();
  const [selectedConcessionaria, setSelectedConcessionaria] =
    useState<ISelectOptions | null>(null);

  const loadOptions = (nome: string) =>
    buscarConcessionarias(nome)
      .then((data) =>
        data.content.map((item) => ({
          value: item.uuid,
          label: item.nome,
          element: item,
        })),
      )
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          Tracking.error(
            "mapa:agendamento/domicilio:buscar-concessionarias-falhou",
            { mensagem },
          );
          toast.error(mensagem);
          return [];
        },
      );

  useEffect(() => {
    setValue("telefone", maskPhone(telefoneDigitado));
  }, [telefoneDigitado, setValue]);

  return {
    control,
    handleSubmit,
    register,
    errors,
    loadOptions,
    selectedConcessionaria,
    setSelectedConcessionaria,
  };
};
